import { useEffect, useState } from "react";
import ProductsListBgColorNoneP0 from "./ProductsListBgColorNoneP0"

interface CountdownProps {
    endTime: string; // yyyy-mm-dd hh:mm:ss
    title: string;
}

export default function CampaignCountdown({ endTime, title }: CountdownProps) {
    const calculateTimeLeft = () => {
        const now = new Date().getTime();
        const target = new Date(endTime).getTime();
        const distance = target - now;

        if (distance <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

        return {
            days: Math.floor(distance / (1000 * 60 * 60 * 24)),
            hours: Math.floor((distance / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((distance / (1000 * 60)) % 60),
            seconds: Math.floor((distance / 1000) % 60),
        };
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
        <div className="styles_wrapperSlider__1UaJZ" id="campaign-9EWLF">
            <div className="styles_wrapperTitle__OSLjq">

                {/* LEFT TITLE */}
                <div className="styles_flexBasis__jC8QR">
                    <div className="MuiBox-root css-0">
                        <div className="MuiGrid-root styles_wrapper_icon_name__zDLid MuiGrid-container">
                            <div className="MuiGrid-root MuiGrid-item">
                                <img
                                    alt="icon mega sale"
                                    src="https://cdn-web-next.thuocsi.vn/images/deals/mega_sale.svg"
                                />
                            </div>

                            <div className="MuiGrid-root MuiGrid-item" style={{ flex: "1 1 0%" }}>
                                <p className="MuiTypography-root styles_title__esM0Y MuiTypography-body1">
                                    {title}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* RIGHT COUNTDOWN */}
                {endTime !== "" && (
                    <div className="styles_flex__vEzd3">
                        <div className="styles_container__cNG6N styles_haveDays__qjdgU">

                            <div className="styles_wrapper_date__QnmfL">
                                <p className="MuiTypography-root styles_date__V1oQF MuiTypography-body1">
                                    {timeLeft.days} ngày
                                </p>
                            </div>

                            <div className="styles_colon__4IHky">:</div>

                            <div className="styles_wrapper_time__t8Si5">
                                <p className="MuiTypography-root styles_time__mnMde MuiTypography-body1">
                                    {String(timeLeft.hours).padStart(2, "0")}
                                </p>
                            </div>

                            <div className="styles_colon__4IHky">:</div>

                            <div className="styles_wrapper_time__t8Si5">
                                <p className="MuiTypography-root styles_time__mnMde MuiTypography-body1">
                                    {String(timeLeft.minutes).padStart(2, "0")}
                                </p>
                            </div>

                            <div className="styles_colon__4IHky">:</div>

                            <div className="styles_wrapper_time__t8Si5">
                                <p className="MuiTypography-root styles_time__mnMde MuiTypography-body1">
                                    {String(timeLeft.seconds).padStart(2, "0")}
                                </p>
                            </div>

                        </div>

                        <button
                            className="MuiButtonBase-root MuiButton-root MuiButton-text styles_btn_from_to__cmIRG styles_active_fromDate_btn__8BHs6"
                            type="button"
                        >
                            <span className="MuiButton-label">
                                Từ &nbsp;<span>15-12</span>&nbsp; Đến &nbsp;<span>31-12</span>
                            </span>
                        </button>
                    </div>
                )}
            </div>
            <div className="mt-[8px]">
                <ProductsListBgColorNoneP0 />
                <div className="styles_seeAllContainer__9tVf0 MuiBox-root css-0">
                    <a className="styles_seeAll___XmLX" href="/promotion/3q43g-clearance-near-expire--mien-nam?code=3Q43G">Xem tất cả</a>
                </div>
            </div>
        </div>
    );
}
